export default __webpack_public_path__ + "static/media/8.27c918c5.svg";